import React, { useState,useContext } from "react";
import "./Swap.css";
import SwapEthToEcr from './EthToEcr'
import SwapEcrToEth from './EcrToEth'


export default function Swap(){
  let [swapchild,setswapchild]=useState(true)
  return (
    <>
    {
      swapchild 
      ? <SwapEthToEcr setswapchild={setswapchild}/> 
      : <SwapEcrToEth setswapchild={setswapchild}/>
    }
    </>
  )
}

